import PropTypes from "prop-types"
import React from "react"
import Relay from "react-relay"
import { injectIntl } from "react-intl"
import { find } from "lodash/collection"
import Icon from "./Icon"
import { licenseTypes } from "../../scripts/licenseTypes"
import { messages as licenseMessages } from "../../messages/licenses"
import settingsMessages from "../../messages/settings"
import { getAccountSettings } from "../../scripts/accountSettings"

class Licence extends React.Component {
  static propTypes = {
    resource: PropTypes.object.isRequired
  }

  render() {
    const { resource, intl } = this.props
    const { license: licenseProp } = JSON.parse(resource.custom_fields)

    const license = find(licenseTypes, { name: licenseProp ? licenseProp.value : "" })
    const {
      settings: { contact_email: contactEmail }
    } = getAccountSettings(
      intl.formatMessage(settingsMessages.authenticAccountId)
    )
    const label =
      license && license.label in licenseMessages
        ? intl.formatMessage(licenseMessages[license.label], {
            email: contactEmail
          })
        : ""

    return license ? (
      <span>
        {license.url && (
          <a title={license.label} target="_blank" href={license.url}>
            <Icon icon={"licence-" + resource.license} />
            <span className="small" itemProp="license">
              {" "}
              {label}
            </span>
          </a>
        )}
        {!license.url && (
          <div>
            <Icon icon={"licence-" + resource.license} />
            <span className="small" itemProp="license">
              {" "}
              {label}
            </span>
          </div>
        )}
      </span>
    ) : null
  }
}

export default Relay.createContainer(injectIntl(Licence), {
  fragments: {
    resource: () => Relay.QL`
      fragment on Resource {
        id
        custom_fields
      }
    `
  }
})



// WEBPACK FOOTER //
// ./webapp/components/elements/Licence.js